import React, { useState } from 'react'
import { CustomCheckbox } from '../CustomInputs/CustomCheckbox'
import { IS_BLACK_FRIDAY } from '../../utils/globals'
import hook from '../../static/icons/png/ll_checkmark.png'
import styled from '@emotion/styled'
import { breakpoints, colors, fontSizes, fonts } from '../../utils/styles'
import { useTranslation } from 'react-i18next'
import addToMailchimp from 'gatsby-plugin-mailchimp'

const StInput = styled.input`
  border: none;
  font-family: ${fonts.regular};
  font-size: ${fontSizes.text};
  padding-bottom: 0.3rem;
  border-bottom: 1px solid ${colors.darkGray};
  width: 70%;
  outline: none;
  margin-bottom: 2.5rem;
  -webkit-appearance: none;
  -webkit-border-radius: 0;
  background-color: transparent;

  ::placeholder {
    color: ${props => (!props.valid ? colors.lobsterRed : colors.placeholderGray)};
    font-family: ${fonts.regular};
  }

  @media (max-width: ${breakpoints.xxl}px) {
    width: 95%;
  }

  @media (max-width: ${breakpoints.l}px) {
    font-size: ${fontSizes.textMobile};
  }
`

const StSubmitButton = styled.button`
  all: unset;
  width: 260px;
  height: 60px;
  font-family: ${fonts.regular};
  font-size: ${fontSizes.addToBagButton};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.lemonadeYellow};
  margin-top: 1rem;
  margin-bottom: 1rem;
  letter-spacing: 2px;
  cursor: pointer;
  color: ${colors.darkGrayNoInverter};

  @media (max-width: ${breakpoints.l}px) {
    width: 100%;
    font-size: ${fontSizes.footerText};
  }
`

const PrivacyLink = styled.a`
  text-decoration: underline;
  color: ${colors.darkGray};
`

const PrivacyContainer = styled.label`
  display: flex;
  color: ${colors.darkGray};
`

const ErrorMessage = styled.label`
  color: ${colors.lobsterRed};
  font-size: ${fontSizes.subHeadlineDefault};
  @media (max-width: ${breakpoints.s}px) {
    font-size: ${fontSizes.footerTextSmall};
  }
`
const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const SuccessMessageContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 2em 0;
  align-items: center;
  font-size: ${fontSizes.footerText};
`

const StInfoSpan = styled.span`
  font-size: ${fontSizes.subHeadlineDefault};
  white-space: pre-line;

  @media (max-width: ${breakpoints.s}px) {
    font-size: ${fontSizes.footerTextSmall};
  }
`

const NewsLetterForm = () => {
  const { t } = useTranslation('newsletter')

  const [mail, setMail] = useState('')
  const [mailValid, setMailValid] = useState(true)
  const [mailPlaceholder, setMailPlaceholder] = useState(t('newsletter.form.mail'))
  const [privacyChecked, setPrivacyChecked] = useState(false)
  const [privacyCheckedValid, setPrivacyCheckedValid] = useState(true)
  const [hasBeenSubmitted, setHasBeenSubmitted] = useState(false)
  const [successSubscription, setSuccessSubscription] = useState(null)
  const [errorMessage, setErrorMessage] = useState('')

  const mailregex = new RegExp(
    "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"
  )

  const handleNewsletterSubmit = event => {
    event.preventDefault()
    let privaValid = false
    let emailValid = false

    if (!mailregex.test(mail)) {
      setMailValid(false)
      setMail('')
      setMailPlaceholder(t('newsletter.form.validMail'))
      emailValid = false
    } else {
      setMailPlaceholder(t('newsletter.form.mail'))
      setMailValid(true)
      emailValid = true
    }

    if (!privacyChecked) {
      setPrivacyCheckedValid(false)
      privaValid = false
    } else {
      setPrivacyCheckedValid(true)
      privaValid = true
    }

    if (privaValid && emailValid) {
      addToMailchimp(mail)
        .then(({ msg, result }) => {
          if (result === 'success') {
            setSuccessSubscription(true)
          }
          if (result !== 'success') {
            setSuccessSubscription(false)
            if (msg && msg.includes('is already subscribed'))
              setErrorMessage(mail + t('newsletter.error.isAlreadySubscribed'))
            else setErrorMessage(t('Something went wrong. Please try again later...'))
          }
        })
        .catch(err => {
          console.error(err)
          // is always 200. only for debugging msg
        })

      setPrivacyChecked(false)
      setMail('')
      setHasBeenSubmitted(true)
    }
  }

  return (
    <>
      <StInput
        onChange={e => setMail(e.target.value)}
        placeholder={mailPlaceholder}
        value={mail}
        valid={mailValid}
        type="email"
        name="E-mail"
        id={'name'}
      />

      <PrivacyContainer>
        <CustomCheckbox
          checked={privacyChecked}
          valid={privacyCheckedValid}
          onChange={e => {
            setPrivacyChecked(e.target.checked)
            setPrivacyCheckedValid(true)
          }}
          isDarkMode={IS_BLACK_FRIDAY}
        />
        <FlexContainer>
          <StInfoSpan>{t('newsletter.confirmPolicy.text')}</StInfoSpan>
          {!privacyCheckedValid ? (
            <ErrorMessage>{t('newsletter.confirmPolicy.error')}</ErrorMessage>
          ) : null}
        </FlexContainer>
      </PrivacyContainer>

      {!hasBeenSubmitted && successSubscription === null ? (
        <StSubmitButton onClick={event => handleNewsletterSubmit(event)}>
          {t('newsletter.button.signUp')}
        </StSubmitButton>
      ) : successSubscription === true ? (
        <SuccessMessageContainer>
          <img
            style={{
              width: '25px',
              height: '25px',
              margin: '2px 1em 0 2px',
            }}
            src={hook}
            alt={'checked'}
          />
          {t('newsletter.success.text')}
        </SuccessMessageContainer>
      ) : (
        <SuccessMessageContainer>{errorMessage}</SuccessMessageContainer>
      )}
      <StInfoSpan>
        {t('newsletter.noDataTransfered.text')}{' '}
        <PrivacyLink href={'/privacy'}>{t('newsletter.privacyPolicy')}</PrivacyLink>.
      </StInfoSpan>
    </>
  )
}

export default NewsLetterForm
